import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, truncateDate, addDate } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConteoGuiasParams;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGenerar: () => Promise<void>;
}

/**
* Componente para editar un Entity
*/
export class ReporteConteoGuiaFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
        };
    }


    render() {
        const { value, onGenerar } = this.props;
        const getField = this.getField;

        const DateF = getField(kea.DateTime);

        return (
            <div>
                <kea.Title titulo="Reporte de conteo de guías" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <DateF field="FechaInicio" label="Fecha de inicio" />,
                    <DateF field="FechaFinal" label="Fecha final" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group">
                            <kea.Button onClick={() => {
                                const now = new Date();
                                const month = truncateDate(now, "months");
                                const lastMonth = addDate(month, "months", -1);
                                const endLastMonth = addDate(month, "days", -1);
                                this.props.onChange({
                                    FechaInicio: lastMonth,
                                    FechaFinal: endLastMonth
                                });
                            }} >
                                Mes pasado
                        </kea.Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Genrar reporte" onClick={onGenerar} style="success" />
                    </div>
                </div>
            </div>);
    }
}

export const ReporteConteoGuiaForm = componentToRx(ReporteConteoGuiaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteconteoguia/form.tsx